function initPdfImageSlider(section) {
  if (section.dataset.sliderInitialized) return;
  section.dataset.sliderInitialized = "true";

  // Find the trigger button using the known class pattern
  const fullscreenTrigger = section.querySelector(
    '[class*="open-fullscreen-"]',
  );
  if (!fullscreenTrigger) {
    console.warn("No fullscreen trigger found in section", section);
    return;
  }

  // Extract suffix reliably
  const match = fullscreenTrigger.className.match(/open-fullscreen-([^\s]+)/);
  const suffix = match ? match[1] : null;
  if (!suffix) {
    console.warn(
      "Could not extract suffix from fullscreen trigger",
      fullscreenTrigger,
    );
    return;
  }

  const container = section.querySelector(".slider-container-image");
  if (!container) return;

  const slides = container.querySelectorAll(".slide");
  const prevBtn = section.querySelector('[data-slider="prev"]');
  const nextBtn = section.querySelector('[data-slider="next"]');
  const downloadBtn = section.querySelector(`#slider-download-${suffix}`);

  let currentIndex = 0;
  container.dataset.currentIndex = "0";

  // ── Image slider navigation ───────────────────────────────────────
  if (slides.length > 1) {
    function updateArrows() {
      if (prevBtn) prevBtn.style.opacity = currentIndex === 0 ? "0.4" : "1";
      if (nextBtn)
        nextBtn.style.opacity =
          currentIndex === slides.length - 1 ? "0.4" : "1";
    }

    function showImageSlide(idx) {
      slides.forEach((slide, i) => slide.classList.toggle("active", i === idx));
      currentIndex = idx;
      container.dataset.currentIndex = idx.toString();
      updateArrows();

      if (downloadBtn) {
        const activeSlide = slides[idx];
        const img = activeSlide?.querySelector("img");
        if (img) {
          downloadBtn.href = img.src;
          const fname =
            activeSlide.dataset.filename ||
            decodeURIComponent(img.src.split("/").pop().split("?")[0]) ||
            `image-${idx + 1}.jpg`;
          downloadBtn.setAttribute("download", fname);
        }
      }
    }

    showImageSlide(0);

    prevBtn?.addEventListener("click", () => {
      if (currentIndex > 0) showImageSlide(currentIndex - 1);
    });
    nextBtn?.addEventListener("click", () => {
      if (currentIndex < slides.length - 1) showImageSlide(currentIndex + 1);
    });
  } else if (slides.length === 1) {
    if (prevBtn) prevBtn.style.display = "none";
    if (nextBtn) nextBtn.style.display = "none";
  }

  // ── Image modal ───────────────────────────────────────────────────
  const modal = document.getElementById(`image-modal-wrapper-${suffix}`);
  if (modal) {
    const modalSlides = modal.querySelectorAll(".image-modal-slide");
    const closeBtn = modal.querySelector(`#image-modal-close-${suffix}`);
    const modalPrevBtn = modal.querySelector(`#image-modal-prev-${suffix}`);
    const modalNextBtn = modal.querySelector(`#image-modal-next-${suffix}`);
    const footerGrid = modal.querySelector(
      `#image-modal-footer-grid-${suffix}`,
    );

    let modalIndex = 0;

    function showModalImage(idx) {
      idx = Math.max(0, Math.min(idx, modalSlides.length - 1));
      modalSlides.forEach((s, i) => s.classList.toggle("hidden", i !== idx));
      modalIndex = idx;

      if (modalPrevBtn)
        modalPrevBtn.style.display = idx === 0 ? "none" : "flex";
      if (modalNextBtn)
        modalNextBtn.style.display =
          idx === modalSlides.length - 1 ? "none" : "flex";

      if (footerGrid?.children?.length === 2) {
        const [left, right] = footerGrid.children;
        left.classList.toggle(
          "col-span-2",
          idx === modalSlides.length - 1 && idx !== 0,
        );
        right.classList.toggle(
          "col-span-2",
          idx === 0 && idx !== modalSlides.length - 1,
        );
      }
    }

    fullscreenTrigger.addEventListener("click", () => {
      const startIdx = parseInt(container.dataset.currentIndex || "0", 10);
      modal.classList.remove("hidden");
      document.body.style.overflow = "hidden";
      showModalImage(startIdx);
    });

    function closeModal() {
      modal.classList.add("hidden");
      document.body.style.overflow = "";
    }

    closeBtn?.addEventListener("click", closeModal);
    modal?.addEventListener("click", (e) => {
      if (e.target === modal) closeModal();
    });

    modalPrevBtn?.addEventListener("click", () => {
      if (modalIndex > 0) showModalImage(modalIndex - 1);
    });
    modalNextBtn?.addEventListener("click", () => {
      if (modalIndex < modalSlides.length - 1) showModalImage(modalIndex + 1);
    });
  }

  // ── PDF fullscreen trigger ────────────────────────────────────────
  fullscreenTrigger.addEventListener("click", () => {
    // For PDF we try native DFlip fullscreen
    const dflipFsBtn = section.querySelector(".df-ui-btn.df-ui-fullscreen");
    if (dflipFsBtn) {
      dflipFsBtn.click();
    }
    // For images the modal handler above will run (multiple listeners are fine)
  });

  // Keyboard support when modal is open
  document.addEventListener("keydown", (e) => {
    if (modal?.classList.contains("hidden")) return;
    if (e.key === "Escape") closeModal?.();
    if (e.key === "ArrowLeft") modalPrevBtn?.click();
    if (e.key === "ArrowRight") modalNextBtn?.click();
  });
}

// Initialize & observe
function initAllSliders() {
  document
    .querySelectorAll('[data-testid="section-pdf-and-image-slider"]')
    .forEach(initPdfImageSlider);
}

document.addEventListener("DOMContentLoaded", initAllSliders);

const mo = new MutationObserver(initAllSliders);
mo.observe(document.body, { childList: true, subtree: true });
